import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useProgressPageStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    //...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalM),
  },

  spacing: {
   // height: tokens.spacingVerticalXXL,
  },

  progressContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ...shorthands.gap(tokens.spacingVerticalM),
    ...shorthands.padding(tokens.spacingVerticalXXL, tokens.spacingHorizontalXL),
  },

  iconLoading: {
    width: '64px',
    height: '64px',
    color: tokens.colorBrandBackground,
  },

  iconError: {
    width: '64px',
    height: '64px',
    color: tokens.colorPaletteRedBackground3,
  },

  progressLoadingMessage: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightMedium,
    color: tokens.colorNeutralForeground1,
    textAlign: 'center',
    marginTop: tokens.spacingVerticalS,
  },

  progressErrorMessage: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightMedium,
    color: tokens.colorPaletteRedForeground1,
    textAlign: 'center',
    marginTop: tokens.spacingVerticalS,
  },

  progressSuccessMessage: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorPaletteGreenForeground1,
    textAlign: 'center',
    marginBottom: tokens.spacingVerticalS,
  },

  progressBar: {
    width: '100%',
    maxWidth: '400px',
    height: '20px',
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusMedium,
    marginTop: tokens.spacingVerticalM,
    position: 'relative',
    overflow: 'hidden',
    boxShadow: `inset 0 1px 3px ${tokens.colorNeutralShadowAmbient}`,
  },

  progressBarFill: {
    height: '100%',
    background: `linear-gradient(90deg, ${tokens.colorBrandBackground}, ${tokens.colorBrandBackgroundPressed})`,
    borderRadius: tokens.borderRadiusMedium,
    transition: 'width 0.3s ease',
    position: 'relative',
    width: 'var(--progress-width, 0%)',

    '&::after': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
      animationName: {
        '0%': { transform: 'translateX(-100%)' },
        '100%': { transform: 'translateX(100%)' },
      },
      animationDuration: '2s',
      animationIterationCount: 'infinite',
    },
  },

  progressText: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    textShadow: `0 1px 2px ${tokens.colorNeutralBackgroundAlpha}`,
  },

  successIcon: {
    fontSize: '64px',
    color: tokens.colorPaletteGreenForeground1,
    marginBottom: tokens.spacingVerticalM,
    animationName: {
      '0%': { transform: 'scale(0.8)', opacity: '0' },
      '50%': { transform: 'scale(1.1)' },
      '100%': { transform: 'scale(1)', opacity: '1' },
    },
    animationDuration: '0.6s',
    animationTimingFunction: 'ease-out',
  },

  autoReturnMessage: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200,
    textAlign: 'center',
    fontStyle: 'italic',
  },

  backButton: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    border: 'none',
    borderRadius: tokens.borderRadiusSmall,
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    marginTop: tokens.spacingVerticalM,
    cursor: 'pointer',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    transition: 'background-color 0.2s ease',

    ':hover': {
      backgroundColor: tokens.colorBrandBackgroundHover,
    },

    ':active': {
      backgroundColor: tokens.colorBrandBackgroundPressed,
    },
  },

  confirmationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: tokens.spacingVerticalM,
    ...shorthands.gap(tokens.spacingVerticalL),
    //...shorthands.padding(tokens.spacingVerticalXL),
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusMedium,
    boxShadow: tokens.shadow8,
    maxWidth: '98%',
    minWidth: '98%',
  },

  confirmationButtons: {
    display: 'flex',
    ...shorthands.gap(tokens.spacingHorizontalM),
    justifyContent: 'center',
  },

  confirmationButtonNo: {
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground1,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusSmall,
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    cursor: 'pointer',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    minWidth: '80px',
    transition: 'all 0.2s ease',

    ':hover': {
      backgroundColor: tokens.colorNeutralBackground3Hover,
    },

    ':active': {
      backgroundColor: tokens.colorNeutralBackground3Pressed,
    },
  },

  confirmationButtonYes: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    border: 'none',
    borderRadius: tokens.borderRadiusSmall,
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    cursor: 'pointer',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    minWidth: '80px',
    transition: 'all 0.2s ease',

    ':hover': {
      backgroundColor: tokens.colorBrandBackgroundHover,
    },

    ':active': {
      backgroundColor: tokens.colorBrandBackgroundPressed,
    },
  },

  confirmationMessage: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    textAlign: 'center',
    lineHeight: tokens.lineHeightBase400,
  },

  confirmationTitle: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    textAlign: 'center',
    marginBottom: tokens.spacingVerticalS,
  },
});
